module.exports = __webpack_public_path__ + "static/img/Campton-Bold.ffeae1e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Campton-Bold.svg
// module id = rVG2
// module chunks = 1